import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

export class UnstyledLink extends PureComponent {
  render() {
    const { external, url, ...rest } = this.props

    const target = external ? '_blank' : undefined
    const rel = external ? 'noopener noreferrer' : undefined
    if (external) {
      return <a target={target} {...rest} href={url} rel={rel} />
    } else {
      return <Link target={target} {...rest} to={url} />
    }
  }
}

export default UnstyledLink
UnstyledLink.propTypes = {
  external: PropTypes.bool,
  url: PropTypes.string,
}



// WEBPACK FOOTER //
// ./src/components/UnstyledLink/index.js